<h1 mat-dialog-title>{{ 'AI_ASSISTANT.SETTINGS.IMAGE_UPLOAD.CHANGE_APPEARANCE' | translate }}</h1>

<mat-dialog-content>
  @switch (state()) {
    @case ('view') {
      <div class="image-preview">
        <glxy-avatar [src]="data.imageURL" [svgIcon]="data.defaultSvg" [width]="220"></glxy-avatar>

        <div class="image-actions">
          <button mat-stroked-button (click)="this.state.set('change')">Change</button>
          @if (data.imageURL) {
            <button mat-stroked-button (click)="onRemove()">Remove</button>
          }
        </div>
      </div>
    }
    @case ('change') {
      @if (!file()) {
        <glxy-image-uploader
          [hintText]="'AI_ASSISTANT.SETTINGS.IMAGE_UPLOAD.HINT' | translate"
          [maxFiles]="1"
          (fileUploadErrored)="onError($event)"
          (fileUploaded)="onUpload($event)"
          (filesChanged)="onFilesChanged($event)"
          [accept]="'.png,.jpg,.jpeg'"
        ></glxy-image-uploader>
      } @else {
        <glxy-image-editor
          [maxEditorHeight]="'300px'"
          [fileInfo]="file()"
          [align]="'start'"
          [maxDimensions]="{ width: 400, height: 400 }"
          [aspectRatios]="[{ label: '1:1', value: 1, selected: true }]"
          (closed)="endEdit($event)"
          class="image-editor"
        />
      }
    }
  }
</mat-dialog-content>
